<template lang="pug">
  .notifications-view
    .notifications-table-wrapper
      .notifications-wrapper
        .actions
          SearchWithButtons.search(
              v-model="search"
              :showSearch="true"
              :clientSide="true"
              style="margin-top: 22px; width: 300px;"
            )
          .filter
            span Transmitter Filter
            FilterSensorTransmitter(
              v-model="transmitterId"
            )
          .filter
            span Info Filter
            FilterInfoType(
              v-model="infoType"
            )
          .filter
            span Status Filter
            FilterStatus(
              :statuses= "statuses"
              v-model="selectedStatus"
            )
          .filter
            span Snooze Type Filter
            FilterStatus(
              :statuses= "statusesSnooze"
              v-model="selectedSnoozeStatus"
            )
          el-button.btnn.dark-green-btn(
            @click="markAllAsSeen"
            :loading="loadingBtn"
          ) {{ $t('notifications.actions.mark_all_as_seen') }}
          el-button.btnn.dark-green-btn(
            @click="handleManageSnoozeNotifications"
            :loading="loadingBtn"
          ) {{ $t('notifications.actions.configure_snooze') }}
        .table-wrapper
          el-row
            el-col(:span='24')
              NotificationsTable(
                :sensor="soilSensor"
                :chartData="sensorInfos"
                :chartType="chartType"
                :datetime="dateRange"
                :notifications="notifications"
                :loading="loading"
                :loadingBtns="loadingBtn"
                :isMobile="isMobile"
              )
      .pagination
        Pagination(
          :view="'notifications'"
          :transmitterId="transmitterId"
          :fieldId="selectedFieldId"
          :infoType="infoType"
          :search="search"
          :isMobile="isMobile"
          :activeName="selectedStatus"
          :activeSnooze="selectedSnoozeStatus"
          @viewData="handleGetNotifications"
          @handleTableLoading="handleLoading"
        )
</template>

<script>
import { filterUtils } from "@utils/filterUtils";
import SearchWithButtons from "@components/_shared/SearchWithButtons";
import NotificationsList from "@components/client/notifications/NotificationsList";
import NotificationsTable from "@components/client/notifications/NotificationsTable";
import SoilSensorsList from "@components/client/details/SoilSensorsList";
import FilterDatePicker from "@components/_shared/FilterDatePicker";
import FilterSensorTransmitter from "@components/_shared/FilterSensorTransmitterDropdown";
import FilterInfoType from "@components/_shared/FilterInfoTypeDropdown";
import FilterStatus from "@components/_shared/FilterStatus";
import Pagination from "@components/_shared/Pagination";
import { mapActions, mapMutations, mapState } from "vuex";
import { general } from "@src/services/dynamicViews/general";
export default {
  name: "NotificationsView",
  mixins: [filterUtils, general],

  components: {
    NotificationsList,
    NotificationsTable,
    SoilSensorsList,
    SearchWithButtons,
    Pagination,
    FilterDatePicker,
    FilterSensorTransmitter,
    FilterInfoType,
    FilterStatus
  },

  data() {
    return {
      loading: false,
      loadingBtn: false,
      selectedFieldId: "",
      transmitterId: "",
      infoType:"",
      search: "",
      chartType: null,
      sensorInfos: null,
      generatePausedForSeconds: false,
      reload: false,
      dateRange: [],
      transmitters: [],
      soilSensors: [],
      notifications: [],
      resetKey: null,
      fieldsInfoSettings: [],
      fieldName: "",
      statuses: [
        { name: "Not seen", value: 'not_seen' },
        { name: "All", value: 'all' },
        { name: "Seen", value: 'seen' }
      ],
      selectedStatus: "not_seen",
      statusesSnooze: [
        { name: "Active snooze", value: 'true' },
        { name: "Inactive snooze", value: 'false' },
        { name: "None", value: 'all' }
      ],
      selectedSnoozeStatus: "all",
      isMobile: false,
    }
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("soilSensor", ["soilSensor"]),
    ...mapState("field", ["selectedField", "selectedFieldInfoSettings"]),

  },

  created(){
    if(this.selectedField && this.selectedField != "all"){
      this.selectedFieldId = this.selectedField.id.toString();
    }      
    else {
      this.selectedFieldId = "all";
    }
  },

  mounted() {
    this.checkMobile();
      window.addEventListener('resize', this.checkMobile);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkMobile);
  },

  watch: {
    selectedField(){
      if(this.selectedField && this.selectedField != "all"){
        this.selectedFieldId = this.selectedField.id.toString();
      }
      else {
        this.selectedFieldId = "all";
      }
    },

    async soilSensor() {
      await this.handleGetField();
      await this.handleChange(this.dateRange);
    },

    // async reload(val) {
    //   if (val) {
    //     this.handleLoading(true);
    //     await this.handleChange(this.dateRange);
    //     this.handleLoading(false);
    //   }
    // }
  },

  methods: {
    ...mapActions('sensorInfo', ['getSoilSensorInfo']),
    ...mapActions("field", ["getFieldInfoSettings"]),
    ...mapActions("transmitter", ["getTransmitter"]),
    ...mapActions("notification", ["updateNotifications"]),

    ...mapMutations("notification", ["setShouldFetchNotifications"]),
    ...mapMutations("snoozeNotification", ["setShouldFetchSnoozeNotifications"]),
    ...mapMutations("dialog", ["showManageSnoozeNotificationsDialog"]),

    checkMobile() {
      this.isMobile = window.innerWidth <= 1400;
    },

    handleGetTransmitters(data) {
      this.transmitters = data;
    },

    handleGetSoilSensors(data) {
      this.soilSensors = data;
    },

    handleGetNotifications(data) {
      this.notifications = data;
    },

    async markAllAsSeen() {
      this.loadingBtn = true;
      await Promise.all(this.notifications.map(n =>
        this.updateNotifications(n.id, { seen: true })
      ));
      this.setShouldFetchNotifications(true);
      this.loadingBtn = false;
    },

    handleManageSnoozeNotifications() {
      this.setShouldFetchSnoozeNotifications(true);
      this.showManageSnoozeNotificationsDialog();
    },

    handleLoading(loading) {
      this.loading = loading;
      // if(!loading) {
      //   setTimeout(() => this.generatePausedForSeconds = loading, 2000);
      // }else {      
      //   this.generatePausedForSeconds = loading;
      // }
      // this.reload = false;
    },

    reloadData(){
      this.resetKey = Date.now();
      this.reload = true;
    },

    handlePaginationLoading(loading) {
      this.loading = loading
    },

    async handleChange(values) {
      let computedParams;
      if(this.soilSensor) {
        if (values && values.length > 0) {
          let dateRangeComputed = {
            start_date: values[0],
            end_date: values[1],
          };
          this.dateRange = [dateRangeComputed.start_date, dateRangeComputed.end_date];
          computedParams = `?by_soil_sensor_id=${this.soilSensor.id}&by_date_range[start_date]=${dateRangeComputed.start_date}&by_date_range[end_date]=${dateRangeComputed.end_date}`;

          const response = await this.getSoilSensorInfo(computedParams);
          this.sensorInfos = response;
        } 
        else {
          this.sensorInfos = [];
        }
      }
    },

    async handleGetField(){
      const transmitterResponse = await this.getTransmitter(this.soilSensor.sensor_transmitter.id);

      if( transmitterResponse.data && transmitterResponse.data.field) {
        let fieldId = transmitterResponse.data.field.id;
        this.fieldName = transmitterResponse.data.field_name;
        const response = await this.getFieldInfoSettings(`?by_field_id=${fieldId}`);

        this.fieldsInfoSettings = response.data.map((item) => ({
          id: item.id,
          info_type: item.info_type || '',
          info_type_unit: item.info_type_unit || '',
          range1s: parseFloat(item.range1s) || 0,
          range1e: parseFloat(item.range1e) || 0,
          range1color: item.range1color || '',
          range2s: parseFloat(item.range2s) || 0,
          range2e: parseFloat(item.range2e) || 0,
          range2color: item.range2color || '',
          range3s: parseFloat(item.range3s) || 0,
          range3e: parseFloat(item.range3e) || 0,
          range3color: item.range3color || ''
        }));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@variables";

.container {

  @media (max-width: 1400px) {
    flex-direction: column;

    .notifications-table-wrapper {
      width: 100%;

      .notifications-wrapper {
        display: grid;
        grid-template-rows: auto;
        grid-template-areas: 
        "header"
        "main"
        "footer";
        width: 100%;
        max-width: 1200px; // limit table area expansion

        .actions {
          grid-area: header;
          width: 100%;
          display: grid;
          padding: 15px;
        }

        .table-wrapper {
          grid-area: main;
          width: 100%;
          overflow-x: scroll;
          max-width: 650px;
          // margin: 0 auto; // centers the table inside grid area
        }

      }
    }


  }
}
</style>